import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { ReceiveTransaction, ShipTransaction } from '~/front-models/transactionGrid';
import { ComponentBase } from '~/infrastructure/component-base';
import { GridFieldSummary } from '~/models/modules/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { AccountsService } from '~/services/administration.ts/accounts';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationsService } from '~/services/modules/stocks/locations';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { ReportViewerPopupComponent } from '~/shared/components/viewer/popup.component';
import { InventoryListing } from '~/models/modules/inventory';
import { InventoriesService } from '~/services/modules/stocks/inventories';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';

import { PickListService } from '~/services/modules/stocks/picklists';
import { FileInfo, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { StockPickListDetailsListing, StockPickLstDetailsSummary } from '~/models/modules/pickList';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { FormatService } from '~/services/administration.ts/format';
import { SharedService } from '~/services/sharedService';
import { TabPosition } from '@progress/kendo-angular-layout';
import { NoteComponent } from '~/shared/components/note/note.component';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { StockAdminPicklistSettingsComponent } from '~/modules/stocks/administration/web-transactions/picklist-settings/picklist-settings.component';
import { AnyARecord } from 'dns';
import { fileSources } from '~/shared/enums/fileSources';
import { FileSelectedStream } from '~/models/modules/file';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { FilesService } from '~/services/modules/stocks/files';

@Component({
    selector: 'app-stock-picklist-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockPicklistUpsertComponent extends ComponentBase implements OnInit {
  _showDocumentsGrid: boolean = false;
  _selectedDocumentsKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _fileSource: fileSources;
  _uploadedStream: FileSelectedStream[] = [];
  _selectedExistingFiles: FileSelectedStream[] = [];
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _selectedAccounts: any[] = [];
  _uploaderSelectMessage: string = 'Upload file..';
  _selectedObjectDocuments: any[] = [];

  uploadSaveUrl = "saveUrl";
  uploadRemoveUrl = "removeUrl";
  _currentUser: UserSummary;
  _active: boolean;
  _theme: string;
  _form: FormGroup;
  _barcodePopupForm: FormGroup;
  _barcodePopupFormFields: any = [];
  _invalidForm: boolean;
  _model: any;
  _selectedAccount = new FormControl();

  _sortingSelected = new FormControl('old');
  _quickScan = new FormControl();
  _defaultQuantity = new FormControl();
  _defaultDate = new FormControl();
  _autoCodeGeneration = new FormControl();
  _inventoryCode = new FormControl();
  _quantity = new FormControl();
  _expirationDate = new FormControl();
  _sites: any[];
  _sitesFiltered: any[];
  _locations: any[];
  _locationsFiltered: any[];
  _purchaseOrders: any[];
  _purchaseOrdersFiltered: any[];
  _vendors: any[];
  _vendorsFiltered: any[];
  _selectedStockItem = new FormControl();
  _items: any[];
  _itemsFiltered: any[];
  _inventoryGridData: any[] = []; //create Picklist Transaction class for the grid
  _itemType: 'standard' | 'batch' | 'serial' | 'serial-with-quantity' | 'non-inventory';
  _barcodePopupActive: boolean;
  _minDate: Date = new Date(1901, 1, 1);
  _printReceipt = new FormControl();
  _showInventoriesGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];
  _inventoryItemsGridColumns: GridFieldSummary[];
  _settingsPrintReceipt: any;
  transactionId: number;
  showReports: boolean = false;
  _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
  receiveReports: any;
  _poPreference: any;
  _addNewStockSettingEnabled: boolean = true; //get from receive settings
  _itemFilter: string;
  _personIDtData: Array<string> = [
    'Person 1',
    'Person 2',
    'Person 3'
  ];
  _isNew: boolean;
  _addClassActive: boolean = false;
  OpenSignAndProcessForm: boolean = false;
  OpenCreateShippingAndProcessForm: boolean = false;
  _inventoriesFiltered: InventoryListing[];
  _inventories: InventoryListing[];
  _selectedInventoriesFromGrid: any[] = [];
  _selectedInventoryItem = new FormControl();
  _fromLocation = new FormControl();
  _gridFromLocation = new FormControl();
  stream = new FormControl();
  _file: File;
  _fileStream: any;
  _selectFile: boolean = false;
  _isOs: boolean;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _page: string = 'pickList';
  _permissionScope = 'pickList';
  _pageState: PageState;
  _selectedLabelId: number;
  _selectedTabId: number;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isAddTabFormValue: boolean = false;
  _selectedAccountIds: any[] = [];
  _customTabs: any;
  _selectedLabelObjectCode: any;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _customFields: CustomFieldSummary[][] = [];
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _language: string = "en";
  _gridFieldText: GridFieldTextSummary[];
  _gridFieldAuth: GridFieldAuthorization[];
  _deactivatedFieldsGridData: Array<any> = [];
  okCloseSubscription: any = null;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _customFieldsValue: any;
  _customFieldsDictionary: { [key: string]: string } = {};

  digitNumber: number;

  _isEditForms: boolean = false;

  _datePickerFormat: string;

  _inventoriesallitems: InventoryListing[];

  reactivate: boolean = false;
  reactivateItem: any;

  _dialogComponentName: string;
  _isDialiog: boolean = false;

  _dialogModel: any;

  copyModelId: number;


  @ViewChild('kendo_combo_Pack_list') kendoComboPackList: ComboBoxComponent;
  @ViewChild('Kendo_Input_Transaction_note') KendoInputTransactionnote: ElementRef;
  @ViewChild('kendoRadioButtonInput') kendoRadioButtonInput: ElementRef;
  @ViewChild('kendo_combo_Person_ID') kendocomboPersonID: ComboBoxComponent;
  @ViewChild('Kendo_Input_Notes') KendoInputNotes: ElementRef;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
  @ViewChild('kendo_transaction_code_input') KendoInputCode: ElementRef;
  @ViewChild('kendo_combo_from_location') kendoComboFromLocation: ComboBoxComponent;
  @ViewChild('new_quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('kendo_combo_inventory') inventoryCombo: ComboBoxComponent;
  @ViewChild('kendo_uploader') upload: UploadComponent;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('kendo_Input_Picklist_Description') kendoInputPicklistDescription: ElementRef;
  @ViewChild('kendo_uploader_wrapper') uploadWrapper: ElementRef;

  constructor(
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _locationsService: LocationsService,
    private _receiveTransactionsService: ReceiveTransactionsService,
    private _stockItemsService: StockItemsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private _securityService: SecurityService,
    private _inventoriesService: InventoriesService,
    private _pickListService: PickListService,
    private _customFieldsService: CustomFieldsService,
    private _formatService: FormatService,
    private _filesService: FilesService,
    private _sharedService: SharedService,
    private _renderer2: Renderer2
  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._getdata();
    this._layoutManager.applyOverly();

    this._gridFields
      .getGridFieldsByPage('inventories')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('inventories', data);
      });

    // this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('inventories', (gridColumns) => {
    //           this._inventoryItemsGridColumns = gridColumns;
    //           if (this._showInventoriesGrid == true) {
    //               //this._showInventoriesGrid = false;
    //               setTimeout(() => {
    //                   this._showInventoriesGrid = true;
    //               });
    //           }
    //       }));
    //   this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('inventories', (gridColumns) => {
    //     this._inventoryItemsGridColumns = gridColumns;
    //     if (this._showInventoriesGrid == true) {
    //         //this._showInventoriesGrid = false;
    //         // setTimeout(() => {
    //         //     this._showInventoriesGrid = true;
    //         // });
    //     }
    // }));
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('inventories', (gridColumns) => {
      this._inventoryItemsGridColumns = gridColumns;

    }));

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    }

    this._currentUser = this._securityService.currentUser;
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model && this._model.id > 0) {

      this.copyModelId = this._model.id;
      this._model.id = null;
      this.itemPickListId = null;
      this._model.conditionId = null;
    }
  }
  _onEditForms() {
    this._isEditForms = true;
  }
  _selectedInventoryKeys: any = []
  _onRowObjectSelectionindexList(e: any[]) {
    if (e.length > 0) {
      let selectedrowsindex = e.map((a) => a.index);
      if (this._selectedInventoryKeys != undefined && this._selectedInventoryKeys != null && this._selectedInventoryKeys.length > 0) {
        selectedrowsindex.forEach((x: any) => {
          let isexist = this._selectedInventoryKeys.find((d: any) => d == x);
          if (isexist == undefined) {
            this._selectedInventoryKeys.push(x);
          }
        })
      }
      else
        this._selectedInventoryKeys = selectedrowsindex;
    }
  }
  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }
  reloadlist: any;
  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    //  this.submodel = this._sharedService.model.submodel ;

    //  if( this.submodel !== undefined && this.reloadlist === undefined && this.submodel !== null){
    //   this.reloadlist = this.submodel.split('-', 1) ;
    //   }
    //   if(this.openfromlist === true ){
    //   this.reloadlist = undefined  ;
    // }

    var closeComponent = {
      component: 'pickList',
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('pickList');
    this._layoutManager.setFromChanged('pickList');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};

  }
  filteredValues: any[];
  siteId: string = JSON.parse(localStorage.getItem('loggedInAccountSites'))[0].siteId;

  ngOnInit() {

    this._initForm();
    this._OpenAccount();

    this.getFormTabs();
    this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    this.getAuth();
    let windowSize = window.innerWidth;

    this._sortingSelected.valueChanges.subscribe((x) => {
      this._inventoryGridData.reverse();
    });

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
    // if (this._pageState == PageState.ADD) {
    //   setTimeout(() => {
    //     this.kendoBarcodeGenStockNumber.nativeElement.focus();
    //   }, 500);
    // }


  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    }
    else {
      setTimeout(() => {
        this.KendoInputCode?.nativeElement?.focus();
      }, 200);
    }
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _selectInventoriesHandler(): void {

    if (this._currentUser.isEnterprise && !this._selectedAccount.value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select Account',
        withoutConfirm: true
      });
    } else {
      this._showInventoriesGrid = true;
    }

  }
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _closeInventoriesWindow(): void {
    this._showInventoriesGrid = false;
  }

  getPropByString(obj: any, propString: any) {
    if (!propString)
      return obj;

    if (propString == 'expirationDate') {
    }
    var prop, props = propString.split('.');

    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
      prop = props[i];

      var candidate = obj[prop];
      if (candidate !== undefined) {
        obj = candidate;
      } else {
        break;
      }
    }
    if (obj) {
      let test = obj[props[i]];
      return test
    }

  }
  _returnSelectedInventoriessHandler(e: any[]): void {
    this._showInventoriesGrid = false;
    this._selectedInventoriesFromGrid.forEach((item: any) => {
      this._handleInventoriesChange(item);
    });
  }
  _onStockRowSelectionChanges(e: any[]) {
    this._selectedStocks = [];
    e.forEach((item) => {
      this._selectedStocks.push(item);
    });
  }
  _selectedItemLocations: any[];
  _returnSelectedStocksHandler(e: any[]): void {
    this._showInventoriesGrid = false;
    this._selectedInventoriesFromGrid.forEach((item: any) => {
      this._handleInventoriesChange(item);
    });


    let stringparam: string = '';
    let value: any;
    let all = this._selectedStocks.map((x: any) => x.id);
    let resu: any;

    all.forEach((a: string) => {
      stringparam = stringparam + a.toString().concat(',');
    });
    stringparam = stringparam.slice(0, stringparam.length - 1);


    let locAvailabilityMap = new Map<number, number>();
    this._inventoriesService.getInventoryListIds(stringparam)
      //
      .subscribe((data) => {

        let mappedInv = data;
        //let mappedInv = this._inventoriesallitems.filter(d => d.inventoryNumber == value.inventoryNumber);
        mappedInv.forEach((inv: any) => {
          if (data.filter((x: any) => x.inventoryNumber == inv.inventoryNumber)) {
            locAvailabilityMap.set(inv.locationId, inv.availability);
          }
        });

        data.filter((x: any) => x.itemLocations?.forEach((loc: any) => {
          loc.availability = locAvailabilityMap.get(loc.id);
        }));

        data.filter((x: any) => x.availability != undefined);
        this._selectedItemLocations = data;
        this._selectedStocks.forEach((item: any) => {
          this._inventoryCode.setValue('');
          this._itemType = this.getItemType(item?.stockItem?.itemType?.name);

          if (this._itemType === 'standard' || !this._autoCodeGeneration.value) {

            if (this._itemType === 'standard') {
              this._inventoryCode.setValue(item.number);
              this._expirationDate.setValue(null);
            }
            let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
            let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);

            let _Gquantity = this._itemType === 'serial' ? (this._quantity.value ? parseInt(this._quantity.value) : 0) :
              (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);


            if (!gridItem) {
              if (data.filter((x: any) => x.id == item.id)) {
                var selectedItem = data.filter((x: any) => x.id == item.id).shift();

                this._inventoryGridData.push({
                  pickListDetailsId: item.id,
                  inventoryCode: item.inventoryNumber,
                  rowindex: maxrowindex,
                  itemNumber: item.stockItem.number === null || item.stockItem.number === '' ? item.inventoryNumber : item.stockItem?.number,
                  itemId: item.stockItem?.id,
                  description: item.stockItem?.description,
                  code: item.location?.code,
                  id: item.location?.id,
                  availableQty: item.availability,
                  availability: item.availability,
                  orderQty: selectedItem.stockItem.itemType.id == 2 ? 1 : 0,
                  uomcode: item.stockItem?.inventoryUnitOfMeasure?.code,
                  itemLocations: selectedItem.itemLocations,
                  itemLocationsFiltered: selectedItem.itemLocations,
                  stockItem: selectedItem.stockItem,
                  stocklocation: selectedItem.stockLocation,
                  selectedLocation: item.location,
                  fromlocationId: item.location.id
                });
              }
            }
          } else {
            if (this._itemType !== 'non-inventory' && this._autoCodeGeneration.value) {
              this.runGenerateBarcode(item);
            }
          }
        });

      });
  }

  _getInventoryItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null
      && this._form.get('site').value != null && this._form.get('site').value.id != null) {
      model.SiteId = this._form.get('site').value.id;
    }
    return this._inventoriesService.getInventories(params, model);
  }


  _onInventoryRowSelectionChanges(e: any[]) {
    this._selectedInventoriesFromGrid = [];
    e.forEach((item) => {
      this._selectedInventoriesFromGrid.push(item);
    });
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
    if (this._itemType == 'serial') {
      setTimeout(() => {
        this._initBarCodePopupForm();
      }, 500);
    }
  }
  // _generateBarcodeClick() {
  //   this.runGenerateBarcode();
  // }



  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }


  _handleVendorsFilter(value: any) {
    this._vendorsFiltered = this._vendors.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadLocationsDD(siteId: number) {
    return this._locationsService.getLocationListingBySite(siteId)
      .subscribe((data: any) => {
        this._locations = data;
        this._locationsFiltered = data;
      });
  }

  _handleLocationsFilter(value: any) {
    this._locationsFiltered = this._locations.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handlePurchaseOrdersFilter(value: any) {
    if (this._poPreference != 'notValidated') {
      this._purchaseOrdersFiltered = this._purchaseOrders.filter(
        (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    }
  }

  _loadItemsDD(siteId: number, selectedItemId: number = null) {
    return this._stockItemsService.getStockItemsListingBySite(siteId)
      .subscribe((data: any) => {
        this._items = data;
        this._itemsFiltered = data;
        if (selectedItemId != null) {
          var newStock = this._items.filter(x => x.id == selectedItemId)[0];
          this.quantityInput.focus();
          setTimeout(() => {
            this._selectedStockItem.setValue(newStock);
            this._form.patchValue({
              selectedStock: { id: newStock.id, number: newStock.number }
            });
          });
        }
      });
  }

  _handleItemsFilter(value: any) {
    this._itemFilter = value;
    this._itemsFiltered = this._items.filter((item) => {
      return (item.number.toString().toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        item.description?.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        item.itemType.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    })
  }

  _handleItemsChange(value: any) {
    if (value != null) {
      setTimeout(() => {
        this.quantityInput.focus();
      });
    }
  }

  // _addNewStock() {
  //     var value = this._itemFilter;
  //     if (this._addNewStockSettingEnabled && typeof value === 'string' && this._items.findIndex(item => item.number === value) == -1) {
  //         var _accountSites: any[] = [];
  //         _accountSites.push({
  //             siteId: this._form.get('site').value.id,
  //             accountId: this._selectedAccount.value.id
  //         });
  //         var model: any = {};
  //         model.number = value;
  //         model.itemTypeId = 1;
  //         model.costTypeId = 1;
  //         model.receiveUnitOfMeasureId = 1;
  //         model.inventoryUnitOfMeasureId = 1;
  //         model.issueUnitOfMeasureId = 1;
  //         model['fileIds'] = [];
  //         model['vendorIds'] = [];
  //         model['stockItemAlternateCodes'] = [];
  //         model['accountSites'] = _accountSites;
  //         this._stockItemsService
  //             .createStockItem(model)
  //             
  //             .subscribe((response: any) => {
  //                 if (response != null && typeof response === 'number') {
  //                     this._loadItemsDD(this._form.get('site').value.id, parseInt(response.toString()));
  //                 }
  //             });
  //     }
  // }

  _dateChanged(selectedDate: Date) {
    if (selectedDate >= this._minDate) {
      this._quantitySubmited();
    }
  }

  _quantitySubmited() {



    this._invalidForm = false;
    switch (this._itemType) {
      case "serial":
        if (this._inventoryCode.value == "" || this._inventoryCode.value == null) {
          var generateBarcodeRan = false;
          if (this._selectedInventoryItem.value && this._autoCodeGeneration.value) {
            this.runGenerateBarcode();
            generateBarcodeRan = true;
          }
          if (generateBarcodeRan) {
            setTimeout(() => {
              this._initBarCodePopupForm();
            }, 500);
          } else {
            this._initBarCodePopupForm();
          }
          return;
        }
        break;
      case "batch":
      case "serial-with-quantity":
        // if (this._inventoryCode.value == "" || this._inventoryCode.value == null) {
        //     this.inventoryIdInput.nativeElement.focus();
        //     return;
        // }
        break;
    }


    this.fillGrid();
    this._onClear(true);
    this.inventoryCombo.focus();
    this.inventoryCombo.toggle(true);
  }
  itemPickListId: number;
  private _initForm() {
    this._model.code = this._model.code ?? null;

    let defaultSiteId = null;
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    if (loggedInAccountSites != "") {
      try {
        defaultSiteId = JSON.parse(loggedInAccountSites)[0]?.siteId;
      } catch (e) {
        defaultSiteId = null;
      }
    }

    this._form = this._fb.group({
      code: [this._pageState === PageState.COPY ? null : this._model?.code, Validators.required],
      description: [this._model?.description ?? null, this.getLabel('LBL_PickListDescription')?.isRequired ? Validators.required : null],
      closed: [{ value: this._model?.picked?.toString() ?? 'false', disabled: this._pageState === PageState.ADD || this._pageState === PageState.COPY || this._pageState === PageState.VIEW }, this.getLabel('LBL_PickListPicked')?.isRequired ? Validators.required : null],
      closedDate: [this._model?.pickDate && this._model?.pickDate != '0001-01-01T00:00:00+00:00' ? new Date(this._model?.pickDate) : null, this.getLabel('LBL_PickListPickedDate')?.isRequired ? Validators.required : null],
      stream: this.stream,
      site: [this._model?.siteId ?? defaultSiteId, null]
    });
    if (this._pageState == PageState.COPY)
      this._pageState = PageState.ADD;

    if (defaultSiteId) {
      this._loadInventories(defaultSiteId);
    }

    if (this._model && this._model?.stockPickListDetails != null) {
      this.RetrieveStockpicListDetails(this._model);
    }
  }

  RetrieveStockpicListDetails(detailsModel: any) {
    if (this._pageState === PageState.COPY || this.copyModelId != null || !this._model?.id) {
      this.itemPickListId = null;
    } else {
      this.itemPickListId = detailsModel.id;
    }
    this._showInventoriesGrid = false;
    this._inventoryGridData = [];
    if (!detailsModel?.stockPickListDetails || detailsModel.stockPickListDetails.length === 0) {
      return;
    }
    let stringparam: string = '';
    let all = detailsModel.stockPickListDetails
      .map((x: any) => x.stockLocation?.id ?? x.stockLocationId)
      .filter((id: any) => id != null);
    all.forEach((a: any) => {
      stringparam = stringparam + a.toString().concat(',');
    });
    stringparam = stringparam.slice(0, stringparam.length - 1);
    if (!stringparam) {
      return;
    }
    this._inventoriesService.getInventoryListIds(stringparam)
      .subscribe((data) => {
        this._inventoryGridData = [];
        detailsModel.stockPickListDetails.forEach((item: any) => {
          let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;
          const locId = item.stockLocationId ?? item.stockLocation?.id;
          var selectedItem = data.filter((x: any) => x.id == locId).shift();
          const detailId = (this._pageState === PageState.COPY || this.copyModelId != null || !this._model?.id) ? 0 : item.id;
          this._inventoryGridData.push({
            pickListDetailsId: detailId,
            inventoryCode: item.stockLocation?.inventoryNumber ?? selectedItem?.inventoryNumber,
            itemNumber: item.stockLocation?.stockItem?.number ? item.stockLocation?.stockItem?.number : (item.stockLocation?.inventoryNumber ?? selectedItem?.inventoryNumber),
            itemId: item.stockLocation?.stockItem?.id ?? selectedItem?.stockItem?.id,
            description: item.stockLocation?.stockItem?.description ?? selectedItem?.stockItem?.description,
            fromlocation: item.stockLocation?.location?.id ?? selectedItem?.location?.id,
            fromlocationId: item.stockLocation?.location?.id ?? selectedItem?.location?.id,
            availableQty: item.stockLocation?.availability ?? selectedItem?.availability,
            orderQty: item.quantity,
            uomcode: item.stockLocation?.stockItem?.inventoryUnitOfMeasure?.code ?? selectedItem?.stockItem?.inventoryUnitOfMeasure?.code,
            stockItem: item.stockLocation?.stockItem ?? selectedItem?.stockItem,
            itemLocations: selectedItem?.itemLocations,
            code: selectedItem?.location?.code,
            id: selectedItem?.location?.id,
            selectedLocation: selectedItem?.location,
            stockLocation: selectedItem?.stockLocation ?? item.stockLocation,
            itemLocationsFiltered: selectedItem?.itemLocations,
            locationId: selectedItem?.location?.id,
            rowindex: maxrowindex,
            StockPickListDetailsId: detailId

          });
        });
      });
  }
  _onOrderQuantityChange($event: number, dataItem: any) {
    // if(this._inventoryGridData)
    // {
    //   this._inventoryGridData.find((item: any) => {
    //     if(item.itemId==dataItem.itemId)
    //     {
    //       item.orderQty=$event
    //     }
    //   })
    // }
  }
  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  async _onSave(e: any) {
    if (!this._inventoryGridData || !this._inventoryGridData.length) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add the Inventory ID#s you would like to Issue',
        withoutConfirm: true
      });
    } else if (!this.checkInventoriesValiation()) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the required fields in the grid.',
        withoutConfirm: true
      });
    } else if (this._form.invalid || this._custominvalidForm) {
      this._invalidForm = this._form.invalid;
      this._invalidSubmit = this._custominvalidForm;
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill all required fields.',
        withoutConfirm: true
      });
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        const entries = Object.entries(this._customFieldsValue);
        for (const [index, [key, value]] of entries.entries()) {
          this._customFieldsDictionary[key] = `${value}`;
        }
      }
      if (this._uploadedStream.length > 0 || this._selectedExistingFiles.length > 0) {
        /* let newFiles = this._uploadedStream.filter(f => f.isNew == true);
        let existingFiles = this._uploadedStream.filter(f => f.isNew == false); */
        await this._saveTransactionFiles(e);
      }
      else {
        this._addPickList(e, null);
      }

    }
  }
  async _saveTransactionFiles(e: any) {
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];

    if ((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)) {
      let _filesModel: any[] = [];
      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.picklist;
        _filesModel.push(model);
      });

      await this._filesService
        .createFileRange(_filesModel)

        .toPromise()
        .then((response: number[]) => {
          if (response != null) {

            //let existingIds:number[] = [];
            existingFiles.forEach((v) => {
              let ext = response.find(r => r == v.existingFileId);
              if (ext == undefined) {
                response.push(v.existingFileId);
              }
            });

            this._addPickList(e, response)
          }
        });
    }
  }
  _addPickList(e: any, fileIds?: number[]) {
    this._invalidForm = false;
    const formModel = this._form.value;
    let model: any = {};
    model['customFieldsValue'] = this._customFieldsDictionary;
    model['code'] = formModel.code;
    const rawSite = formModel.site ?? this._form.getRawValue()?.site;
    model['siteId'] = (rawSite && typeof rawSite === 'object') ? (rawSite.id ?? 0) : (rawSite ?? 0);
    model['description'] = formModel.description ?? '';
    const rawClosed = formModel.closed ?? this._form.getRawValue()?.closed;
    model['picked'] = rawClosed === true || rawClosed === 'true';
    model['pickDate'] = formModel.closedDate ?? this._form.getRawValue()?.closedDate;

    if (this._pageState == PageState.ADD || !this._model?.id) {
      this._model = this._model || {};
      this._model.id = null;
      this._model.pickDate = null;
      this.itemPickListId = null;
      model['id'] = 0;
      model['pickDate'] = null;
    }

    model['itemPickListId'] = this._model?.id ?? null;
    if (model['picked'] == null) {
      model['picked'] = this._model.picked;
    }

    model['stockPickListDetails'] = this._inventoryGridData.map((x) => {
      const detailId = (this._pageState === PageState.ADD || !this._model?.id) ? 0 : (x.pickListDetailsId ?? 0);
      const locId = x.fromlocationId ? x.fromlocationId : (x.locationId ?? x.id);
      return {
        id: detailId,
        stockPickListId: this._model?.id ?? 0,
        stockLocationId: x.stockLocationId ?? x.stocklocation?.id ?? x.pickListDetailsId ?? locId,
        quantity: x.orderQty ?? x.quantity ?? 0,
        stockLocation: {
          locationId: locId,
          stockItemId: x.itemId ?? x.stockItemId,
          inventoryNumber: x.inventoryCode
        }
      };
    });

    for (let itm of model['stockPickListDetails']) {
      if (itm.stockLocationId == null || itm.stockLocationId == undefined) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please fill From Location field',
          withoutConfirm: true
        });
        this._invalidForm = true;
        return;
      }
    }

    if (fileIds && fileIds.length > 0) {
      model['stockPickListFiles'] = fileIds.map((v) => {
        return {
          fileId: v
        };
      });
    } else {
      model['stockPickListFiles'] = null;
    }

    if (!this._invalidForm) {
      if (this._model != null && this._model.id != null) {
        this._pickListService
          .updatePickList(this._model.id, model)

          .subscribe((data: any) => {
            var msg = "";
            if (data != null && data.message != null) {
              msg = 'Update Successfully';
            } else {
              msg = 'Error';
            }

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: msg,
              withoutConfirm: true,
              returnAfterOkCloseClick: true
            });
            if (data && data['message'] != null) {
              if (data['message'] == 'Success') {
                this._form.controls['closed'].setValue(true);
                if (e === 'saveAndClose') {
                  model.id = this._model.id;
                  this._closeForm(model);
                } else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._model.id = null;
                  this.itemPickListId = null;
                  this._form.controls.code.setValue(null);
                  this._pageState = PageState.ADD;
                  if (this._inventoryGridData) {
                    this._inventoryGridData.forEach((x: any) => {
                      x.pickListDetailsId = 0;
                      x.StockPickListDetailsId = 0;
                    });
                  }
                } else if (e === 'saveAndNew') {
                  this._pageState = PageState.ADD;
                  this._model = {};
                  this._model.id = null;
                  this.itemPickListId = null;
                  this.copyModelId = null;
                  this._inventoryGridData = [];
                  this._onClear(false);

                }
                else {
                  this.itemPickListId = data.responseId;
                  this._model.id = data.responseId;
                  this._pageState = PageState.EDIT;
                  this._pickListService.getPickListById(data.responseId).subscribe((res: any) => {
                    if (res) {
                      this._model = res;
                      this._model.picked = res.picked;
                      this._form.controls.closed.setValue(res.picked ? res.picked.toString() : 'false');
                      this.RetrieveStockpicListDetails(res);
                    }
                  });
                }
              } else {
                return false;
              }
            }
          });
      } else {
        this._pickListService
          .createPickList(model)
          .subscribe((data: any) => {
            this.transactionId = parseInt(data.message);
            var msg = "";
            if (data != null && data.message != null) {
              this.note?.createNote(this.transactionId);
              msg = 'Added Successfully';
              model.id = this.transactionId;
            } else {
              msg = 'Error';
            }
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: msg,
              withoutConfirm: true,
              returnAfterOkCloseClick: true
            });
            if (data && data['message'] != null) {
              if (data['message'] == 'Success' || this.transactionId > 0) {
                model.id = data.responseId || this.transactionId;
                if (e === 'saveAndClose') {
                  this._closeForm(model);
                } else if (e === 'saveAndCopy') {
                  this.copyModelId = model.id;
                  this._model = {};
                  this._model.id = null;
                  this.itemPickListId = null;
                  this._form.controls.code.setValue(null);
                  this._pageState = PageState.ADD;
                  if (this._inventoryGridData) {
                    this._inventoryGridData.forEach((x: any) => {
                      x.pickListDetailsId = 0;
                      x.StockPickListDetailsId = 0;
                    });
                  }
                } else if (e === 'saveAndNew') {
                  this._pageState = PageState.ADD;
                  this._model = {};
                  this._model.id = null;
                  this.itemPickListId = null;
                  this.copyModelId = null;
                  this._inventoryGridData = [];
                  this._onClear(false);
                } else {
                  this.itemPickListId = model.id;
                  this._model = this._model || {};
                  this._model.id = model.id;
                  this._pageState = PageState.EDIT;
                  this._pickListService.getPickListById(model.id).subscribe((res: any) => {
                    if (res) {
                      this._model = res;
                      this._model.picked = res.picked;
                      this._form.controls.closed.setValue(res.picked ? res.picked.toString() : 'false');
                      this.RetrieveStockpicListDetails(res);
                    }
                  });
                }
              } else {
                return false;
              }
            }
            if (this._printReceipt.value) {
              if (this._settingsPrintReceipt?.receiveReportId != null) {
                this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: this._settingsPrintReceipt.receiveReportId, transactionId: this.transactionId });
                this._onClear();
              }
            }
          });
      }
    }
  }
  _printReceiptReport() {
    this._onClear();
  }

  _openForm(componentName: string, isDocument = false) {
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, isDocument };
    this._isDialiog = true;

    this._isMandatory = false;
  }

  _closeDialog(event: any) {
    if (event?.response && event.component == 'locations') {
      const loggedInAccountSites =
        localStorage.getItem('loggedInAccountSites') ?? '';
      var siteId = JSON.parse(loggedInAccountSites)[0].siteId;
      this._loadLocationsDD(siteId);
      this._form.controls['defaultLocation'].setValue(event.response);
      this._isDialiog = event?.open ?? false;
    } else if (typeof event === 'boolean') {
      this._isDialiog = event;
    } else {
      this._isDialiog = event?.open ?? false;
    }
  }
  _removeHandler({ sender, dataItem }: any) {
    //this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != dataItem.itemNumber);

    this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.rowindex != dataItem.rowindex)
  }


  _onQuantityChange(e: any, item: ReceiveTransaction) {
    item.quantity = e;

    if (item.itemType === 'serial') {
      this.generateBarcode(e)
        .subscribe((data: any) => {
          item.inventoryCode = data.result.toString();
        });
    }
  }

  _onInventoryCodeChange(e: any, item: ReceiveTransaction) {
    item.inventoryCode = e;
  }

  _onExpirationDateChange(e: any, item: ReceiveTransaction) {
    item.expirationDate = e;
  }

  _onClear(isFill: boolean = true) {
    this.transactionId = null;
    if (!isFill) {
      this._selectedDocumentsKeys = [];
      this._uploadedStream = [];
      this._selectedExistingFiles = [];
      this._uploaderSelectMessage = 'Upload file..';
      this._inventoryGridData = [];
      var siteId = this._form.value.site;
      this._form.setValue({
        code: null,
        description: null,
        closed: null,
        site: siteId,
        closedDate: null,
        stream: null
      });
      //this.KendoInputCode.nativeElement.value = null;
      //this._form.value.site=siteValue;
    }
    this._selectedInventoryItem.setValue(null);
    this._fromLocation.setValue(null);
    this._gridFromLocation.setValue(null)
    if (!this._defaultQuantity.value) {
      this._quantity.setValue(null);
    }

  }
  _initBarCodePopupForm() {
    if (!this._barcodePopupActive) {
      let inventoryValues: any[] = [];
      if (this._inventoryCode.value) {
        inventoryValues = this._inventoryCode.value.split(', ');
      }

      let record: any = {};
      for (let i = 0; i < this._quantity.value; i++) {
        record['field' + i] = inventoryValues[i] ? [inventoryValues[i], Validators.required] : [null, Validators.required];
        this._barcodePopupFormFields.push('field' + i);
      }

      this._barcodePopupForm = this._fb.group(record);
      this._barcodePopupActive = true;
      this._layoutManager.applyOverly();
    }
  }

  _barcodePopupClose() {
    this._barcodePopupFormFields = [];
    this._barcodePopupActive = false;
    this._layoutManager.removeOverlay();
  }

  _onBarcodePopupClear(field?: string) {
    if (field) {
      this._barcodePopupForm.get(field).setValue(null);
    } else {
      this._barcodePopupForm.reset();
    }
  }

  _onBarcodePopupSave() {
    let counter = 0;
    let inventoryCode = '';
    Object.keys(this._barcodePopupForm.controls).forEach(key => {
      if (counter > 0) {
        inventoryCode += ', ';
      }

      let fieldValue = this._barcodePopupForm.get(key).value;
      if (fieldValue) {
        inventoryCode += fieldValue;
      }

      counter++;
    });

    this._inventoryCode.setValue(inventoryCode);
    this._barcodePopupClose();

    this._quantitySubmited();
  }

  _barcodePopupGenerateBarcode(field?: string) {
    if (!field) {
      for (const key in this._barcodePopupForm.controls) {
        if (!this._barcodePopupForm.get(key).value) {
          field = key;
          break;
        }
      }
    }

    if (field) {
      this.generateBarcode(1)
        .subscribe((data: any) => {
          this._barcodePopupForm.get(field).setValue(data.result.toString());
        });
    }
  }

  // private runGenerateBarcode(item: StockItemSummary = null) {
  //     let counter = this._itemType === 'serial' ? this._quantity.value : 1;
  //     this.generateBarcode(counter)
  //         .subscribe((data: any) => {
  //             this._inventoryCode.setValue(data.result.toString());
  //             if (item != null) {
  //                 if (item.itemType.id == 1) {
  //                     this._expirationDate.setValue(null);
  //                 }
  //                 let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
  //                 if (!gridItem) {
  //                     this._inventoryGridData.push({
  //                         stockItemId: item.id,
  //                         itemNumber: item.number,
  //                         description: item.description,
  //                         quantity: this._quantity.value ? +this._quantity.value : 0,
  //                         uom: item.receiveUnitOfMeasure.code,
  //                         inventoryCode: this._inventoryCode.value,
  //                         expirationDate: this._expirationDate.value,
  //                         unitCost: item.costInfo?.cost,
  //                         itemType: this.getItemType(item.itemType.name),
  //                         itemTypeId: item.itemType.id,
  //                         minQuantity: item.minqty,
  //                         maxQuantity: item.maxqty
  //                     });
  //                 }
  //             }
  //         });
  // }

  // private runGenerateBarcode() {
  //  // let counter = 1;
  //  let counter = this._itemType === 'serial' ? this._quantity.value : 1;
  //   this.generateBarcode(counter)
  //     .subscribe((data: any) => {
  //       // this._sitemNumber.setValue(data.result.toString());
  //       this._form.patchValue({
  //         code: data.result.toString()
  //       });
  //       // setTimeout(() => {
  //       //   this.kendoComboboxItemType.toggle(true);
  //       //   this.kendoComboboxItemType.focus();
  //       // });
  //       if (this._pageState == PageState.ADD) {
  //         setTimeout(() => {
  //           this.kendoInputPicklistDescription.nativeElement.focus();
  //           let picklistDesc = this.kendoInputPicklistDescription;
  //           picklistDesc.nativeElement.classList.add('focusedInput');
  //         });
  //       }
  //     });
  // }

  private runGenerateBarcode(item: StockItemSummary = null) {
    let counter = this._itemType === 'serial' ? parseInt(this._quantity.value?.toFixed(this.digitNumber)) : 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._inventoryCode.setValue(data.result.toString());
        this._model.code = (this._inventoryCode.value);
        this._form.get("code").setValue(this._inventoryCode.value);
        this._barcodeSubmited();
        if (item != null) {
          if (item.itemType.id == 1) {
            this._expirationDate.setValue(null);
          }
          let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
          let _itemTypeName = this.getItemType(data.itemType.name);

          let _quantity = _itemTypeName === 'serial' ? (this._quantity.value ? parseInt(this._quantity.value) : 0) :
            (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);
          let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;

          if (!gridItem) {
            this._inventoryGridData.push({
              stockItemId: item.id,
              poid: item.id,
              itemNumber: item.number,
              description: item.description,
              quantity: _quantity,// this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
              uom: item.receiveUnitOfMeasure.code,
              inventoryCode: this._inventoryCode.value,
              expirationDate: this._expirationDate.value,
              unitCost: item.costInfo?.cost,
              itemType: this.getItemType(item.itemType.name),
              itemTypeId: item.itemType.id,
              minQuantity: item.minqty,
              maxQuantity: item.maxqty,
              defaultLocation: item.defaultLocation != null ? item.defaultLocation.code : null,
              defaultLocationId: item.defaultLocation != null ? item.defaultLocation.id : null,
              uDField1: null,
              uDField2: null,
              uDField3: null,
              uDFieldDate1: null,
              uDFieldDate2: null,
              uDFieldDate3: null,
              rowindex: maxrowindex
            });
          }
        }
      });
  }
  // private runGenerateBarcode() {
  //   let counter = 1;
  //   this.generateBarcode(counter).subscribe((data: any) => {
  //     this._sitemNumber.setValue(data.result.toString());
  //     this._form.patchValue({
  //       number: data.result.toString(),
  //     });
  //     // setTimeout(() => {
  //     //   this.kendoComboboxItemType.toggle(true);
  //     //   this.kendoComboboxItemType.focus();
  //     // });
  //     if (this._pageState == PageState.ADD) {
  //       setTimeout(() => {
  //         this.kendoStockDescriptionInput.nativeElement.focus();
  //         let StockDesc = this.kendoStockDescriptionInput;
  //         StockDesc.nativeElement.classList.add('focusedInput');
  //       });
  //     }
  //   });
  // }
  private checkInventoriesValiation(): boolean {
    for (let item of this._inventoryGridData) {
      const qty = item.orderQty != null ? +item.orderQty : (item.quantity != null ? +item.quantity : 0);
      if (qty <= 0) {
        return false;
      }
    }

    return true;
  }

  private getItemType(itemTypeName: string) {
    switch (itemTypeName) {
      case 'Standard':
        return 'standard';
      case 'Serial':
        return 'serial';
      case 'Batch':
        return 'batch';
      case 'Non Inventory':
        return 'non-inventory';
      case 'Serial with Quantity':
        return 'serial-with-quantity';
    }
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('inventories', quantity);
  }



  private fillGrid() {

    let isAddedInventory = this._inventoryGridData.find(x => x.inventoryCode == this._selectedInventoryItem.value.inventoryNumber && x.id == this._fromLocation.value.id);
    if (isAddedInventory != null) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'This item is already added to the grid. Please select another Location.',
        withoutConfirm: true
      });
      return false;
    }
    if (this._quantity.invalid) {
      if (this._quantity.value < 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'The order quantity must be greater than 0.',
          withoutConfirm: true
        });
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'The order quantity should be less than the availability.',
          withoutConfirm: true
        });
      }

    }

    else {
      let maxrowindex = Math.max(...this._inventoryGridData.map(o => o.rowindex), 0) + 1;

      this._inventoryGridData.push({
        inventoryCode: this._selectedInventoryItem.value.inventoryNumber,
        itemNumber: this._selectedInventoryItem.value.stockItem.number ? this._selectedInventoryItem.value.stockItem.number : this._selectedInventoryItem.value.inventoryNumber,
        itemId: this._selectedInventoryItem.value.stockItem.id,
        rowindex: maxrowindex,
        description: this._selectedInventoryItem.value.stockItem.description,
        code: this._fromLocation.value.code,
        id: this._fromLocation.value.id ? this._fromLocation.value.id : this._selectedInventoryItem.value.locationId,
        pickListDetailsId: 0,
        availableQty: this._fromLocation.value?.availability?.toFixed(this.digitNumber),
        orderQty: this._quantity.value,
        uomcode: this._selectedInventoryItem.value.stockItem.inventoryUnitOfMeasure.code,
        itemLocations: this._selectedInventoryItem.value.itemLocations,
        itemLocationsFiltered: this._selectedInventoryItem.value.itemLocationsFiltered,
        stockItem: this._selectedInventoryItem.value.stockItem,
        stocklocation: this._selectedInventoryItem.value.stockLocation,
        selectedLocation: this._fromLocation.value,
        StockPickListDetailsId: 0,
        fromlocationId: this._fromLocation.value.id
      });
    }
  }


  _handleInventoriesChange(value: any, isFetch: boolean = false) {


    setTimeout(() => {
      if (value) {
        this._inventoriesService.getInventoryById(value.id)

          .subscribe((data) => {
            let locAvailabilityMap = new Map<number, number>();
            if (this.siteId) {
              var itemLocationsForSpecificSite = ((data.itemLocations) as any[])?.filter(item => item?.site?.id == this.siteId)
              data.itemLocations = itemLocationsForSpecificSite
            }
            //New//
            if (this._form.value.site == null)
              this._form.value.site = data.site.id;
            this._inventoriesService.
              GetByInventoryNumberAndSiteAndLocationId(this._form.value.site,
                value.inventoryNumber, null).subscribe((response: any) => {
                  let mappedInv = response;

                  mappedInv.forEach((inv: any) => {
                    if (inv.inventoryNumber == value.inventoryNumber) {
                      locAvailabilityMap.set(inv.locationId, inv.availability);
                    }
                  });
                  data.itemLocations?.forEach((loc: any) => {
                    // loc.availability = locAvailabilityMap.get(loc.id);
                  })

                  if (this._selectedInventoriesFromGrid && this._selectedInventoriesFromGrid.length > 0) {
                    this._selectedInventoryItem.setValue({
                      ...this._selectedInventoriesFromGrid[0],
                      itemLocations: data.itemLocations,
                      itemLocationsFiltered: data.itemLocations,
                      availability: data.availability,
                      stockLocation: data.stockLocation,
                      location: data.location,
                      stockItem: data.stockItem,
                      selectedLocation: data.location
                    });
                    this._selectedInventoriesFromGrid = [];
                  }

                  else {
                    this._selectedInventoryItem.setValue({
                      ...this._selectedInventoryItem.value,
                      itemLocations: data.itemLocations,
                      itemLocationsFiltered: data.itemLocations,
                      availability: data.availability,
                      stockLocation: data.stockLocation,
                      location: data.location,
                      stockItem: data.stockItem,
                      selectedLocation: data.location
                    })
                  }

                  this._inventoryGridData.forEach((itm: any) => {
                    if (itm.pickListDetailsId == value.id) {
                      itm.itemLocations = data.itemLocations;
                      itm.stockItem = data.stockItem;
                      itm.selectedLocation = data.location;
                      itm.code = data.location.code;
                      itm.id = data.location.id;
                    }
                  });
                  if (value.stockItem.itemType.name == "Serial") {
                    this._fromLocation.setValue(this._selectedInventoryItem.value?.itemLocationsFiltered[0]);
                    this._quantity.setValue(value.availability);
                    this._quantitySubmited();
                  }
                  else {
                    this.kendoComboFromLocation.focus();
                    this.kendoComboFromLocation.toggle(true);
                  }
                });
          });
      }

    });
    if (!value) {
      this._fromLocation.setValue(null)
      this._quantity.setValue(0);
    }
  }
  _handleFromLocationChange(value: any, dataItem: any) {
    let arraylocation: any[] = [];
    let itemavailable = this._inventoryGridData.map((a: any) => (a.stocklocation || a.stockLocation));
    itemavailable.forEach((ax: any) => {
      arraylocation.push(...ax)
    })

    if (value != undefined && value != null) {
      let resu = arraylocation.filter((a: any) => (a.locationId == value.id || a.
        locationID == value.id) &&
        a.inventoryNumber.toLowerCase() == dataItem.itemNumber.toLowerCase()).shift();
      dataItem.availableQty = 0;
      if (resu != undefined && resu != null) {
        dataItem.availableQty = resu.availability
        dataItem.fromlocationId = resu.fromlocationId
        dataItem.locationId = resu.locationId
      }
    }
    else {
      dataItem.availableQty = 0;
    }

    let isAddedInventory = this._inventoryGridData.find(x => x.inventoryCode == dataItem.inventoryCode
      && x.id == value.id && x.id != dataItem.id);
    if (isAddedInventory != null) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'This item is already added to the grid with the same location. Please select another location.',
        withoutConfirm: true
      });


      dataItem.selectedLocation = null;
      dataItem.orderQty = 0;

    }

  }
  _handleInventoriesFilter(value: any) {
    this.beginScroll = false;
    if (this.timeOut) clearTimeout(this.timeOut);
    var doneTypingInterval = 10;  //time in ms, 5 seconds for example
    this.timeOut = setTimeout(() => {
      this.comboBoxpagingationParams.search = value;
      this.comboBoxpagingationParams.currentItem = '0';
      this.comboBoxpagingationParams.pagenumber += 1;

      if (this._model != null && this._model.id != null && this._model.site != null && this._model.site.id != null) {
        this._loadInventories(this._model.site.id);
      }
      else {
        var siteId = this._form.get('site').value;
        this._loadInventories(siteId);
      };
    }, doneTypingInterval);
  }


  comboBoxpagingationParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1,
    pagenumber: 1
  };
  filterarray: any = [];
  _loadInventories(siteId: number) {
    if (!this.beginScroll) {
      this.comboBoxpagingationParams = {
        currentItem: '0',
        totalbyPage: 20,
        search: this.comboBoxpagingationParams.search != '' ? this.comboBoxpagingationParams.search : '',
        page: 1,
        pagenumber: 1
      };

      return this._inventoriesService.getInventoryListing2(siteId, this.comboBoxpagingationParams)
        .subscribe((data: any) => {
          this._inventoriesFiltered = data.body;
          this._inventoriesFiltered = this._inventoriesFiltered.filter((item, i, arr) => arr.findIndex(t => t.inventoryNumber === item.inventoryNumber) === i);
        });


    } else {
      if (this.comboBoxpagingationParams.page == 1) this.comboBoxpagingationParams.page = 3;
      return this._inventoriesService.getInventoryListing2(siteId, this.comboBoxpagingationParams)
        .subscribe((data: any) => {

          if (data.body.length) {
            if (this._inventoriesFiltered.length) {
              data.body.forEach((a: any) => {
                let resualt = this._inventoriesFiltered.find((d: any) => d.inventoryNumber === a.inventoryNumber);
                if (resualt === undefined) {
                  this.filterarray.push(data.body.find((d: any) => d.inventoryNumber === a.inventoryNumber));
                }

              });
              this._inventoriesFiltered = [...this._inventoriesFiltered, ...this.filterarray];
              this._inventoriesFiltered = this._inventoriesFiltered.filter((item, i, arr) => arr.findIndex(t => t.inventoryNumber === item.inventoryNumber) === i);
              this.filterarray = [];

              if (this.comboBoxpagingationParams != null)
                this.comboBoxpagingationParams.page += 1;

            }

          }
        });
    }

  }
  isOpened: boolean = false;
  timeOut: any;
  clearTimeout: any;
  beginScroll: boolean = false;


  scrollCombobox(event: any) {
    this.isOpened = true;
    this.beginScroll = false;
    if (this.isOpened) {
      this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
        if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
          this.beginScroll = true;
          this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
          // this.comboBoxpagingationParams.page += 1;
          var siteId = this._form.get('site').value;
          this._loadInventories(siteId);
        }
      });
    }
    // }, 100);
  }
  onBlur() {
    this.beginScroll = false;
    this._inventories = [];
    this._inventoriesFiltered = [];
    this.comboBoxpagingationParams.currentItem = '0';
    //this.comboBoxpagingationParams.page += 1;
    var siteId = this._form.get('site').value;
    this._loadInventories(siteId);
  }



  _handleFromLocationsFilter(value: any, dataItem: any) {
    dataItem.fromLocationFiltered = dataItem.fromLocation.filter(
      (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _formLocationValueChange() {
    if (this._fromLocation.value) {
      setTimeout(() => {
        this.quantityInput.focus();
      }, 100);
    }

  }

  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onloadend = () => {
          this._fileStream = reader.result;
          if (this.checkFileExtention()) {
            let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
              stream: reader.result,
              size: file.rawFile.size,
              type: file.rawFile.type,
              name: file.rawFile.name,
              fileSource: fileSources.picklist,
              isNew: true
            });
            this._uploadedStream.push(_selectedFileModel);

          }
        };
      }
    });
    this._selectFile = this._fileSelectedChanges.length > 0;
  }

  private checkFileExtention(): boolean {
    let fileUploadedName = this._file.name;
    const allowedExtensions = ['doc', 'docx', 'csv', 'xls', 'xlsx', 'pdf'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1];
    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Only DOC, DOCX, XLS, XLSX, PDF and CSV extensions are allowed.',
        withoutConfirm: true
      });

      setTimeout(() => {
        this.upload.clearFiles();
        this._file = null;
        this._fileStream = null;
      });

      return false;
    } else {
      return true;
    }
  }

  _fileRemoveEventHandler(e: any) {
    let fileName = e.files[0].name;
    let delFile: FileSelectedStream = this._uploadedStream.find(f => f.name.toLowerCase() == fileName.toLowerCase());
    if (delFile != undefined) {
      let indx = this._uploadedStream.indexOf(delFile);
      this._uploadedStream.splice(indx, 1);

    }
    this._fileStream = null;
  }

  _addNewStock() {
    var value = this._itemFilter;
    if (this._addNewStockSettingEnabled && typeof value === 'string' && this._items.findIndex(item => item.number === value) == -1) {
      if (this._currentUser.isEnterprise) {
        var _accountSites: any[] = [];
        _accountSites.push({
          siteId: this._form.get('site').value.id,
          accountId: this._selectedAccount.value.id
        });
        model['accountSites'] = _accountSites;
      }
      var model: any = {};
      model.number = value;
      model.itemTypeId = 1;
      model.costTypeId = 1;
      model.receiveUnitOfMeasureId = 1;
      model.inventoryUnitOfMeasureId = 1;
      model.issueUnitOfMeasureId = 1;
      model['fileIds'] = [];
      model['vendorIds'] = [];
      model['stockItemAlternateCodes'] = [];
      this._stockItemsService
        .createStockItem(model)

        .subscribe((response: any) => {
          if (response != null) {
            this._loadItemsDD(this._form.get('site').value.id, model.number);
          }
        });
    }
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        if (x && Array.isArray(x) && !x.find((tab: any) => tab.name === 'General')) {
          x.unshift({
            id: 1,
            name: 'General',
            order: 1,
            isCustom: false,
            page: this._page
          });
        }
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }


  _addNewField(tabId: number) {
    this._selectedLabelId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      // if (!this._selectedAccounts.length) {

      //   this._layoutComponent.openPopup({
      //     title: 'Validation',
      //     message: 'Please choose the account with the site desired',
      //     withoutConfirm: true
      //   });
      // }
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
      else {
        this._editFormActive = true;
        this._isCustomfieldsFormValue = true;
      }
    }

  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == "stockItems" ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response["message"],
            withoutConfirm: true
          });
          if (response["close"] != null) {
            if (response["close"] == true) {
              // this._closeForm();
            } else {
              return;
            }
          }
        }
        //   this._closeForm();
      });

  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _onCancel() {
    this._closeForm();
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels(true);
    this._initForm();
    this.getFormTabs();
    this.getAuth();
  }


  private loadCustomFields(entityId?: string) {
    //this._pacer.start();
    // this._customFieldsService
    //   .getCustomFields('stock', this._page)
    //   //
    //   .subscribe((data) => {
    //     if (this._model != null && this._model.id != null) {
    //       let that = this;
    //       data.map(function (x) {
    //         x.entityId = that._model.id;
    //       });
    //     }
    //     var tabIds = data.map(item => item.formTabId)
    //       .filter((value, index, self) => self.indexOf(value) === index);

    //     const grouped = this.groupBy(data, (item: { formTabId: any; }) => item.formTabId);
    //     let that = this;
    //     tabIds.forEach(function (formTabId) {
    //       that._customFields[formTabId] = grouped.get(formTabId);
    //     });
    //   });

    // this._customFieldsService
    //   .getFormTabsByPage(this._page)
    //   
    //   .subscribe((data: any) => {
    //     //get custom tabs first
    //     this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
    //   });
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        data = data.filter(x => x.formTab?.page == this._page);

        if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        //this.setMandatoryFields();
      });
    //this._pacer.start()
    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter(
          (x: { isCustom: boolean }) => x.isCustom == true
        );
      });
  }


  private loadLabels(isCloseCustomField: boolean = false) {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        if (isCloseCustomField)
          this._initForm();
      })
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  getLabel(objectCode: any, tabid: any = null) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : null;
    }
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)
      //
      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      })
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
    this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response["message"] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response["message"],
                withoutConfirm: true
              });
              if (response["close"] != null) {
                if (response["close"] == true) {
                  this.loadCustomFields(this._model?.id?.toString());
                  this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    this.loadCustomFields(this._model?.id?.toString());
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }


  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    Object.keys(customFieldsValue).forEach(key => {
      if (customFieldsValue[key] == null || customFieldsValue[key] == "null") {
        customFieldsValue[key] = "";
      }
      if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
        this._customFields[tabId].find(x => x.name == key).entityId = -1;
        this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: "null", entityId: -1, customFieldId: -1 });
      }
      var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
      if (customFieldData != undefined) {
        customFieldData.value = customFieldsValue[key];
      }
    });
    this._customFieldsValue = customFieldsValue;
  }

  _barcodeSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputPicklistDescription.nativeElement.focus();
        let picklistDesc = this.kendoInputPicklistDescription;
        picklistDesc.nativeElement.classList.add('focusedInput');
      });
    }
  }
  _onUploadClick() {

    let kendoUploader = this.uploadWrapper.nativeElement.querySelector('input');
    kendoUploader.click();
  }
  //#region  Search Doc
  _returnSelectedDocumentsHandler(e: any): void {
    this._selectedExistingFiles = [];
    this._selectedDocumentsKeys = [];
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentsGrid = false;
        let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
        this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
          return currentSelected.indexOf(c) === index;
        });
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
      this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
        return currentSelected.indexOf(c) === index;
      });
      this._selectedDocumentsKeys.forEach((v) => {
        let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
          stream: '',
          size: 0,
          type: '',
          name: '',
          fileSource: fileSources.picklist,
          isNew: false,
          existingFileId: v
        });
        this._selectedExistingFiles.push(_selectedFileModel);

        this._uploaderSelectMessage = 'Upload file..' + ` [ ${this._selectedExistingFiles.length} file(s) selected ]`;
      });
    }
  }

  _closeDocumentsWindow(): void {
    this._showDocumentsGrid = false;
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentsGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = true;
    }
  }

  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAllDocuments(this._selectedAccounts, params, model);
  }

  _getSelectedDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  }
  _onDocumentRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }

  _onDocumentbjectRowSelectionChanges(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  //#endregion
}
